import {ModalityCodeEnum, RefundStatusEnum} from 'domain/usecases';

export const CONSULT_REFUND_FILTER_STATUS_ALL = 'all';

export const CONSULT_REFUND_FILTER_MODALITY = {
	ALL: 'all',
	CONSULT: ModalityCodeEnum.MEDICAL_APPOINTMENT,
	SPECIAL_EXAM: ModalityCodeEnum.SPECIAL_EXAMS,
	SIMPLE_EXAM: ModalityCodeEnum.SIMPLE_EXAMS,
	HOSPITALIZATION: ModalityCodeEnum.HOSPITALIZATIONS,
	EMERGENCY: ModalityCodeEnum.EMERGENCY,
	THERAPY: ModalityCodeEnum.THERAPIES,
} as const;

export const DEFAULT_CONSULT_REFUND_V2_FILTERS: {modality: string; status: string} = {
	status: CONSULT_REFUND_FILTER_STATUS_ALL,
	modality: CONSULT_REFUND_FILTER_MODALITY.ALL,
};

export const CONSULT_REFUND_FILTER_STATUS = {
	ALL: CONSULT_REFUND_FILTER_STATUS_ALL,
	APPROVED: String(RefundStatusEnum.APPROVED_7),
	CONCLUDED: String(RefundStatusEnum.CONCLUDED_8),
	CANCELED: String(RefundStatusEnum.CANCELED_4),
	DENIED: String(RefundStatusEnum.DENIED_5),
	IN_ANALYSIS: String(RefundStatusEnum.IN_ANALYSIS_6),
	RECEIVED: String(RefundStatusEnum.REGISTERED_1),
} as const;
